/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export * from './about-extension-list/about-extension-list.component';
export * from './about-github-link/about-github-link.component';
export * from './about-license-list/about-license-list.component';
export * from './about-module-list/module-list.component';
export * from './about-package/package-list.component';
export * from './about-platform-version/about-platform-version.component';
export * from './about-server-settings/about-server-settings.component';
export * from './about-status-list/about-status-list.component';
export * from './about.component';
export * from './about-panel.directive';
export * from './about-repository-info/about-repository-info.component';
export * from './about-repository-info/repository-info.interface';

export * from './about.module';
